export const objectiveIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.report-section-header',
    intro: 'The Objective Pre/Post report is where you can view results from Objective Pre and Posttests for each objective and see progress over time. There are six objectives in the WordFlight System.'
  },
  {
    element: '.student-dropdown-row',
    intro: 'Select a student from the dropdown to view their specific Objective Pre/Post data.'
  },
  {
    element: '#print-button',
    intro: 'Click here to print the Objective Pre/Post report for the selected student.'
  },
  {
    element: '#objective-dropdown',
    intro: 'Select an objective from the dropdown. An objective will appear after a student has reached it in the WordFlight System.'
  },
  {
    element: '.objective-chart-container',
    intro: 'See the student’s Objective Pre and Posttest results for the selected objective. The graph is broken down into four categories: Decoding Words, Using Syllables, Recognizing Words (untimed), and Recognizing Words (timed). Track student progress from the Objective Pre to Posttest.'
  },
  {
    element: '.objective-growth-chart-container',
    intro: 'See the student’s Objective Pre and Posttest Performance growth in a category across objectives.'
  },
  {
    element: '#objective-growth-dropdown',
    intro: 'Select a category from the dropdown. There are four categories: Decoding Words, Using Syllables, Recognizing Words (untimed), and Recognizing Words (timed).'
  }
];
